import { Vue, i18n } from "../../general/vue";
import CategoriesFilter from "../../vue-components/CategoriesFilter.vue";
import BundleBuilder from "../../vue-components/BundleBuilder.vue";
import { initializeBundleBuilderState } from "../../pages/bundleBuilder.js";

initializeBundleBuilderState().then(() => {
  new Vue({
    el: "bundle-builder",
    i18n,
    render: (h) => h(BundleBuilder),
  });
});

new Vue({
  el: "categories-filter",
  i18n,
  render: (h) => h(CategoriesFilter),
});

const categoriesFilterEl = document.querySelector(".js-vue-categories-filter");
if (categoriesFilterEl) {
  const productsCategories = categoriesFilterEl.dataset.categories,
    selectedCategoryId = categoriesFilterEl.dataset.selected;

  // window.$_categoriesFilter = new Vue({
  //     i18n,
  //     render: h => h(CategoriesFilter),
  // }).$mount(".js-vue-categories-filter");

  new Vue({
    el: ".js-vue-categories-filter",
    i18n,
    components: {
      CategoriesFilter,
    },
    template: `<CategoriesFilter :select-category-id="${selectedCategoryId}" :products-categories="${productsCategories}"></CategoriesFilter>`,
  });
}

const filterEl = document.getElementById("filter");
if (filterEl !== null) {
  filterEl.addEventListener("category.changed", function (e) {
    const categoryId = e.detail.category_id;
    const filterCategoryIdInput = document.getElementById("filterCategoryId");

    if (filterCategoryIdInput) {
      filterCategoryIdInput.value = categoryId;
    }

    Filter.submit();
  });
}

const bundleMobileTrigger = document.querySelector(".c-custom-bundle-trigger");
const bundleMobileTriggerClose = document.querySelector(
  ".c-custom-bundle-trigger-close"
);
const bundleEl = document.querySelector(
  ".c-custom-bundle__bundle-builder-wrapper"
);

bundleMobileTrigger.addEventListener("click", () => {
  bundleEl.classList.add("is-active");
});

document.addEventListener("click", (e) => {
  const toggle = e.target.closest(".js-bundle-set-toggle");
  if (!toggle) return;

  const item = toggle.closest(".product__item");
  if (item) {
    item.classList.toggle("is-set-open");
  }
});

if (bundleMobileTriggerClose) {
  bundleMobileTriggerClose.addEventListener("click", () => {
    bundleEl.classList.remove("is-active");
  });
}
